/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Done_LabelInputs */

const en_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const fr_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine`)
};

const de_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt`)
};

const it_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

const ru_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сделанный`)
};

const es_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho`)
};

const zh_cn2_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完毕`)
};

const ja_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`終わり`)
};

const hi_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हो गया`)
};

const pt_pt2_notes_done_label = /** @type {(inputs: Notes_Done_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Notes_Done_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_done_label = /** @type {((inputs?: Notes_Done_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Done_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_done_label(inputs)
	if (locale === "de") return de_notes_done_label(inputs)
	if (locale === "it") return it_notes_done_label(inputs)
	if (locale === "ru") return ru_notes_done_label(inputs)
	if (locale === "es") return es_notes_done_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_done_label(inputs)
	if (locale === "ja") return ja_notes_done_label(inputs)
	if (locale === "hi") return hi_notes_done_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_done_label(inputs)
	return en_notes_done_label(inputs)
});